<div class="fdd-shell">
  <section class="fdd-card fdd-block1">
    <div class="fdd-block1__row1">
      <div class="fdd-block1__left">
        @if (cropFormFields.length) {
          <div class="fdd-form-block fdd-form-block--culture">
            <msf-form-builder
              [fields]="cropFormFields"
              [(model)]="block1FormModel"
              (modelChange)="onBlock1ModelChange($event)"
              flexDirection="column"
            ></msf-form-builder>
          </div>
        }
      </div>
      <div class="fdd-block1__metrics">
        <div>
          <div class="fdd-metric-label">{{ 'FIELD_AREA' | translate }}</div>
          <div class="fdd-metric-value">{{ fieldAreaHa | number: '1.1-2' }} {{ 'HA' | translate }}</div>
        </div>
        <div>
          <div class="fdd-metric-label">{{ 'CADASTRE_NUMBER' | translate }}</div>
          <div class="fdd-metric-value">{{ cadastralNumber || '—' }}</div>
        </div>
        <div>
          <div class="fdd-metric-label">{{ 'FIELD_DETAILS_V2.LAST_SAT_IMG' | translate }}</div>
          <div class="fdd-metric-value">{{ lastSatelliteImageLabel }}</div>
        </div>
        <div>
          <div class="fdd-metric-label">{{ 'FIELD_DETAILS_V2.FIELD_STATUS' | translate }}</div>
          <p-tag [severity]="fieldStatusBadge.severity">
            {{ fieldStatusBadge.labelKey | translate }}
          </p-tag>
        </div>
      </div>
      <div class="fdd-block1__actions">
        <button
          pButton
          type="button"
          icon="pi pi-file-pdf"
          (click)="openReportModal()"
          class="p-button-sm fdd-btn-report"
          [disabled]="!fieldEntity?.id || !selectedSeason?.id"
        >
          <span pButtonLabel>{{ 'FIELD_DETAILS_V2.GENERATE_REPORT' | translate }}</span>
        </button>
      </div>
    </div>

    <div class="fdd-block1-meta-grid">
      <div class="fdd-meta-cell">
        <div class="fdd-meta-cell__label muted">{{ 'FIELD_DETAILS_V2.REGION_DISTRICT' | translate }}</div>
        <div class="fdd-meta-cell__value">{{ fieldRegionDisplay }}</div>
      </div>
      <div class="fdd-meta-cell">
        <div class="fdd-meta-cell__label muted">{{ 'FIELD_DETAILS_V2.AGRICULTURAL_PRODUCER' | translate }}</div>
        <div class="fdd-meta-cell__value">{{ agricultureProducerDisplay }}</div>
      </div>
      <div class="fdd-meta-cell">
        <div class="fdd-meta-cell__label muted">{{ 'FIELD_DETAILS_V2.PLANTING_PLAN_FACT' | translate }}</div>
        <div class="fdd-meta-cell__value">
          @if (selectedSeason; as s) {
            {{ formatSeasonDatePair(s.plantingDatePlan, s.plantingDate) }}
          } @else {
            — / —
          }
        </div>
      </div>
      <div class="fdd-meta-cell">
        <div class="fdd-meta-cell__label muted">{{ 'FIELD_DETAILS_V2.HARVEST_PLAN_FACT' | translate }}</div>
        <div class="fdd-meta-cell__value">
          @if (selectedSeason; as s2) {
            {{ formatSeasonDatePair(s2.harvestingDatePlan, s2.harvestingDate) }}
          } @else {
            — / —
          }
        </div>
      </div>
      @if (selectedVarietiesDisplay) {
        <div class="fdd-meta-cell fdd-meta-cell--wide">
          <div class="fdd-meta-cell__label muted">{{ 'FIELD_DETAILS_V2.VARIETY_PREVIEW' | translate }}</div>
          <div class="fdd-meta-cell__value">{{ selectedVarietiesDisplay }}</div>
        </div>
      }
    </div>
  </section>

  <app-field-details-timeline-section
    [timelineDatesLoading]="timelineDatesLoading"
    [timelineDates]="timelineDates"
    [selectedTimelineDate]="selectedTimelineDate"
    [anomaliesByDay]="anomaliesByDay"
    [highCloudCoverByDay]="highCloudCoverByDay"
    (calendarOpen)="openCalendarDialog()"
    (datePick)="onTimelinePick($event)"
  />

  <app-field-details-indices-map-chart-row
    [indexOptions]="indexOptions"
    [selectedIndexValue]="selectedIndexValue"
    [selectedTimelineDate]="selectedTimelineDate"
    [indexTileUrl]="indexTileUrl"
    [wmsTileLoading]="wmsTileLoading"
    [wmsOverlayOpacity]="wmsOverlayOpacity"
    [mapCenter]="mapCenter"
    [mapSeasonPolygonJson]="mapSeasonPolygonJson"
    [fieldPolygonJson]="fieldPolygonJson"
    [mapPolygonColorOnMiniMap]="mapPolygonColorOnMiniMap"
    [mapIndexScaleBarGradient]="mapIndexScaleBarGradient"
    [chartLoading]="chartLoading"
    [chartData]="chartData"
    [chartOptions]="chartOptions"
    [cropPhases]="cropPhases"
    [plantingBoundaryDate]="plantingBoundaryDate"
    (indexPick)="selectIndex($event)"
    (wmsOverlayOpacityChange)="onMapChartWmsOpacity($event)"
  />

  <app-field-details-indices-bottom-grid
    [anomaliesLoading]="anomaliesLoading"
    [anomaliesForSelectedDay]="anomaliesForSelectedDay"
    [recommendations]="recommendationsForSelectedDay"
    [focusedRecommendationCode]="focusedRecommendationCode"
    [detailActiveTab]="detailActiveTab"
    [agroMeasures]="agroMeasures"
    [plantingBoundaryDate]="plantingBoundaryDate"
    [fieldPhotosLoading]="fieldPhotosLoading"
    [fieldPhotosProgress]="fieldPhotosProgress"
    [photoStrip]="photoStrip"
    [photosTotal]="photosTotal"
    [dataUpdatedDisplay]="dataUpdatedDisplay"
    (showAnomalyOnMap)="showAnomalyOnMap($event)"
    (detailActiveTabChange)="detailActiveTab = $event"
    (openPhotoSlider)="openPhotoSlider($event)"
    (openPhotoSliderFromMore)="openPhotoSliderFromMore()"
  />
</div>

<p-dialog
  [(visible)]="calendarDialogVisible"
  [modal]="true"
  [header]="'Select date' | translate"
  [style]="{ width: '420px' }"
  [appendTo]="'body'"
  [baseZIndex]="21000"
  styleClass="fdd-dialog fdd-dialog--nested"
>
  @if (calendarFormFields.length) {
    <msf-form-builder
      [fields]="calendarFormFields"
      [(model)]="calendarFormModel"
      flexDirection="column"
    ></msf-form-builder>
  }
  <ng-template pTemplate="footer">
    <div class="fdd-calendar-footer">
      <app-secondary-button
        icon="pi pi-times"
        [title]="'Отменить'"
        (action)="closeCalendarDialog()"
      ></app-secondary-button>
      <app-primary-button
        icon="pi pi-check"
        [title]="'Apply'"
        (action)="applyCalendarSelection()"
      ></app-primary-button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="photoSliderVisible"
  [modal]="true"
  [appendTo]="'body'"
  [baseZIndex]="25000"
  [autoZIndex]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [showHeader]="false"
  [dismissableMask]="true"
  [style]="{ width: 'auto', maxWidth: '96vw' }"
  styleClass="fdd-photo-slider-dialog"
  (onHide)="closePhotoSlider()"
>
  @if (photoSliderImages.length) {
    <div class="fdd-slider fdd-slider--dialog">
      <button type="button" class="fdd-slider-close p-button-text" (click)="closePhotoSlider()">
        <i class="pi pi-times"></i>
      </button>
      <div class="fdd-photo-slider-count" aria-live="polite">
        {{ photoSliderIndex + 1 }} / {{ photoSliderImages.length }}
      </div>
      <button type="button" class="fdd-slider-nav p-button-text" (click)="advancePhotoSlider(-1)">
        <i class="pi pi-chevron-left"></i>
      </button>
      <img [src]="photoSliderImages[photoSliderIndex]" alt="" class="fdd-slider-img" />
      <button type="button" class="fdd-slider-nav p-button-text" (click)="advancePhotoSlider(1)">
        <i class="pi pi-chevron-right"></i>
      </button>
    </div>
  }
</p-dialog>
